<section>
  <h4 class="page-title">Companies Merge</h4>
  <div class="content-wrapper">
    <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(3,minmax(0,1fr))']">
      <kendo-gridlayout-item class="mb-0">
        <h5 class="mb-0">Master Company</h5>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0">
        <h5 class="mb-0">Secondary Company</h5>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item class="mb-0">
        <h5 class="mb-0">Final Company</h5>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-company-select-single-kendo (selectionChanged)="setMasterCompany($event)" [companyId]="masterCompany?.id"
          placeholder="Search for a master company"
          [restrictedCompanyId]="secondaryCompany?.id"></app-company-select-single-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-company-select-single-kendo (selectionChanged)="setSecondaryCompany($event)"
          [companyId]="secondaryCompany?.id" placeholder="Search for a secondary company"
          [restrictedCompanyId]="masterCompany?.id"></app-company-select-single-kendo>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <kendo-button class="mt-24" kendoButton [disabled]="!masterCompany?.id || !secondaryCompany?.id" [themeColor]="'primary'"
          fillMode="solid" iconClass="fa-solid fa-refresh" (click)="reloadPage()">
          Refresh</kendo-button>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-company-information-cards [company]="masterCompany" [cols]="2" (reload)="reload('master')"
          [activeTabIndex]="activeTabIndex" (activatePanelBar)="activeTabIndex = $event"
          [type]="'master'"></app-company-information-cards>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-company-information-cards [company]="secondaryCompany" [cols]="2" (reload)="reload('secondary')"
          [activeTabIndex]="activeTabIndex" (activatePanelBar)="activeTabIndex = $event"
          [type]="'secondary'"></app-company-information-cards>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item>
        <app-company-information-cards [company]="finalCompany" [cols]="2" [type]="'final'"
          [activeTabIndex]="activeTabIndex"
          (activatePanelBar)="activeTabIndex = $event"></app-company-information-cards>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
    <kendo-button kendoButton [disabled]="!masterCompany?.id || !secondaryCompany?.id" [themeColor]="'primary'"
      fillMode="solid" iconClass="fas fa-plus" (click)="mergeCompany()">
      Merge Company</kendo-button>
  </div>
</section>
<ng-template #noData>
  <p class="mt-1">-</p>
</ng-template>
